import { Container, } from '@mui/material';
import { dataConstants } from '../../../src/constants';
import getPageMetaTags from '../../../lib/meta/_getMetaTags';
import StockList from '../../../src/components/Browse/StockList';

export default function BrowseStocks({ themeMode, stocks_data }) {

  return (
    <>
      <Container maxWidth="xl">
        <StockList stockData={stocks_data} />
      </Container>
    </>
  )
}

export async function getStaticProps() {
  const stocks_data = require('../../../public/assets/search/stock.json');
  const meta_tags = (await getPageMetaTags('/blogs', false)) || {}
  const { getMetaTags } = meta_tags || {}

  return {
    props: {
      meta_tags: getMetaTags?.tags || null,
      stocks_data
    },
    revalidate: dataConstants.REVALIDATE_IN.SEVEN_DAYS,
    // notFound: process.env.NODE_ENV !== 'production' ? false : true,
  }
}
